module.exports = __webpack_public_path__ + "img/ethereum-classic.25142b79.png";